import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateProductImage } from "@/lib/api/product.api"
import { useAuthStore } from "@/store/auth.store"

export function useUpdateProductImage(productId: string) {
  const token = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      imageId,
      caption,
      order,
    }: {
      imageId: string
      caption?: string
      order?: number | string
    }) => {
      if (!token) throw new Error("No token available")
      return updateProductImage(productId, imageId, { caption, order }, token)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["product", productId] })
    },
  })
}
